<template>
  <BCard
    header-tag="header"
    body-bg-variant="light"
    body-class="!rounded-b-2xl"
    class="w-50 border rounded"
    style="border-radius: 16px !important;"
  >
    <template #header>
      <div class="d-flex w-100">
        <div class="w-1 mr-1 rounded bg-[#00BC7D]" />
        <div class="w-100">
          <div class="d-flex justify-between w-100">
            <h5 class="font-bold text-black text-xl mb-1">
              {{ title }}
            </h5>
            <div v-if="redirect !== ''">
              <b-button
                variant="outline-secondary"
                size="sm"
                :to="redirect"
              >
                <span class="text-black">Lihat Detail</span>
              </b-button>
            </div>
          </div>
          <div
            :class="!isPdfMode ? 'text-2xl' : 'text-xl'"
            class="d-flex text-[#62748E]"
          >
            Total :
            <b-spinner
              v-if="loading"
              small
              class="align-self-center ml-1"
              variant="secondary"
            />
            <span
              v-else
              class="align-self-center ml-1"
            >{{ IDR(balance) }}</span>
          </div>
        </div>
      </div>
    </template>
    <b-card-text>
      <div
        v-if="loading"
        class="text-center py-2"
      >
        <b-spinner variant="primary" />
      </div>
      <template v-else>
        <div
          class="rounded"
          :class="!isPdfMode ? 'overflow-y-auto' : ''"
          :style="!isPdfMode ? 'max-height: 475px;' : ''"
        >
          <BCard
            v-for="item in list"
            :key="item.id"
            :class="!isPdfMode ? 'my-1' : 'mb-1'"
            class="border my-1"
            style="border-radius: 16px !important;"
          >
            <div class="d-flex gap-10 mb-1">
              <div class="rounded-pill p-[5px] bg-[#F8FAFC] border border-[#F1F5F9] h-14 w-14 flex items-center justify-center">
                <img
                  :src="item.icon"
                  :alt="item.name"
                >
              </div>
              <span class="align-self-center">{{ item.name }}</span>
            </div>
            <div class="font-bold text-2xl text-black">
              {{ IDR(item.balance) }}
            </div>
          </BCard>
        </div>
      </template>
    </b-card-text>
  </BCard>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      default: '',
    },
    balance: {
      type: Number,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    isPdfMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IDR,
    }
  },
}
</script>
